import React, { Component, forwardRef } from 'react'
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as func from "../../../utils/functions";
import * as FActions from "../../../store/modules/footer";

import Item from './item';

class TreeBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // category : this.props.category,
			pkKey : 'category_id',
      depth : 1,
      editIndex : '',
      isOpenChild : false,
      isInit : false,
    }

		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
    this.showMessage = this.showMessage.bind(this);
  }

  // openChild = (isOpen) => {
  //   this.setState({
  //     isOpenChild : isOpen
  //   })
  // }

	onUpdate(index, item, render) {
		const records = this.props.category.map(
      info => index === info[this.state.pkKey]
        ? { ...info, ...item }
        : info
    )
    this.props.setCategory(records)
		if(render)
			this.forceUpdate();
	}

	onRemove(index) {
		const records = this.props.category.filter(f => f[this.state.pkKey] !== index)
    this.props.setCategory(records)
	}

	onEditIndex(id) {
		if(this.state.editIndex === id)
			return;
		if(this.state.editIndex)
			this.refs["ref" + this.state.editIndex].onClose();
		else if(this.refs.ref)
			this.refs.ref.onClose();
		else if(this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex' : id
    })
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

  render() {
    const t = {};
    t.category = [];

    const test = func.deepClone(this.props.category)//,this.props.category

    let tt = {};

    test.map((r, i) => {
      const temp = r;
      temp.category_type = this.props.type;
      temp.children = [];
      if (r.up_category_id === 0) {
        tt[temp.category_id] = temp;
      } else {
        if (tt[r.up_category_id])
          tt[r.up_category_id].children.push(temp)
      }
    });

    Object.keys(tt).map((key) => {
      t.category.push(tt[key])
    });

    return (
      <>
        <div className="card mt-0 p-0 maxWidthInit">
          <table className="table table-thin striped border-bottom mb-0">
            <colgroup>
              <col />
              <col width="180px"/>
              <col width="100px"/>
            </colgroup>
            <thead>
            <tr>
              <th scope="col">타이틀</th>
              <th scope="col">슬러그</th>
              <th scope="col">비고</th>
            </tr>
            </thead>
            <tbody>

            {
              t.category.map((record, index) => {
                return (
                  <Item
                    key={record[this.state.pkKey]}
                    index={record[this.state.pkKey]}
                    ref={"ref" + record[this.state.pkKey]}
                    arrIndex={index}
                    pkKey={this.state.pkKey}
                    record={record}
                    onUpdate={this.onUpdate}
                    onRemove={this.onRemove}
                    onEditIndex={this.onEditIndex}
                    showMessage={this.showMessage}
                    />
                )
              })
            }
            </tbody>
          </table>
        </div>
      </>
    )
  }
}

export default connect(
	(state) => ({
	}),
	(dispatch) => ({
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
) (TreeBox)
